import { analyticsDashboard as TYPES } from './../action_types';
import * as Ajax from './services';
import { dateParams as dateParamsUtil } from './utilities';

const fetch = function () {
  return function (dispatch, getState) {
    if (getState().AnalyticsDashboard.SiteSearches.meta.exhausted) return;
    if (getState().AnalyticsDashboard.SiteSearches.meta.fetching) return;

    dispatch({
      type: TYPES.FETCH_SITE_SEARCHES_REQUEST,
    });

    const dateParams = dateParamsUtil(
      getState().AnalyticsDashboard.DisplayedDates,
    );

    Ajax.SiteSearchesService(dateParams)
      .done(function (hitsResponse) {
        dispatch({
          type: TYPES.FETCH_SITE_SEARCHES_SUCCESS,
          siteSearches: hitsResponse.site_searches,
        });
      })
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_SITE_SEARCHES_FAILURE,
        });
      });
  };
};

const SiteSearches = {
  fetch: fetch,
};
export { SiteSearches };

const initialState = {
  siteSearches: [],
  meta: {
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_SITE_SEARCHES_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_SITE_SEARCHES_SUCCESS:
      return Object.assign({}, state, {
        siteSearches: state.siteSearches.concat(action.siteSearches),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_SITE_SEARCHES_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    case TYPES.SET_DISPLAYED_DATES:
      return initialState;

    default:
      return state;
  }
};

export { reducer, reducer as default };
